export default __webpack_public_path__ + "static/SumeshMajhiResume-462c5691712312332a60ab96dee4ab98.pdf";